import Package from '@/data/package/package';

export default class JsonPackage extends Package {

}
